// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Curry       = require("bs-platform/lib/js/curry.js");
var MaterialUI  = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./TextField.css')));

function valueFromEvent(evt) {
  return evt.target.value;
}

var component = ReasonReact.statelessComponent("TextField");

function make(label, value, onChange, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.element(/* None */0, /* None */0, MaterialUI.FormControl[/* make */0](/* None */0, /* Some */["TextField"], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[
                      ReasonReact.element(/* None */0, /* None */0, MaterialUI.InputLabel[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[{
                                  focused: "TextField-focused"
                                }], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[label])),
                      ReasonReact.element(/* None */0, /* None */0, MaterialUI.Input[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[value], /* Some */[(function (e) {
                                    return Curry._1(onChange, e.target.value);
                                  })], /* None */0, /* Some */["TextField-inputwrapper"], /* None */0, /* array */[]))
                    ]));
    });
  return newrecord;
}

exports.valueFromEvent = valueFromEvent;
exports.component      = component;
exports.make           = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/TextField.re
// module id = 430
// module chunks = 0